import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { Globals } from '../../../globals';
import { AdsServices } from '../services';
import { ProviderFilePage } from '../provider-file/provider-file';

/**
 * Generated class for the DishViewAllergensPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
    selector: 'page-products-ads',
    templateUrl: 'products-ads.html',
})
export class ProductsAdsPage {

    constructor(public navCtrl: NavController,
        public navParams: NavParams,
        public globals: Globals,
        public adsServices: AdsServices) {

        this.getElements();
    }

    async getElements() {
        this.adsServices.actual_page = 'Element list';
        //Recuperamos el proveedor
        await this.adsServices.getElementsAds('3', this.adsServices.actual_page);
    }

    addElement(element, type) {
        this.adsServices.addElement(element, type);
    }

    openProviderFile(provider) {
        this.navCtrl.push(ProviderFilePage, {
            provider: provider
        });
    }

}



// WEBPACK FOOTER //
// ./src/pages/ads/products-ads/products-ads.ts